import { useMemo } from 'react';
import { MOCK_AUDIT_LEDGER } from '../constants/mockActivity.js';
import { DATE_RANGES } from '../constants/activityConfig.js';

/**
 * Filtered Audit Ledger entries by date-range preset and free-text search
 * (actor / action / artifact ID / hash). Server-side scoping in production —
 * this client-side filter is over an already-scoped mock dataset.
 */
export function useAuditLedger({ range, search }) {
  return useMemo(() => {
    const maxHours = DATE_RANGES.find((r) => r.value === range)?.hours ?? Infinity;
    const query = search.trim().toLowerCase();

    const entries = MOCK_AUDIT_LEDGER.filter((entry) => {
      if (entry.ageHours > maxHours) return false;
      if (!query) return true;
      const haystack = `${entry.actor} ${entry.action} ${entry.artifactId} ${entry.hash}`.toLowerCase();
      return haystack.includes(query);
    });

    return { entries };
  }, [range, search]);
}
